import { Injectable } from '@angular/core';
import { LoginDetailsService } from 'src/app/core/login/services/login-details.service';
import { GET_LIST_OF_OFFER_TYPES, GET_PLAYER_TYPE_CLUB_RULES, GET_SITE_IDS } from '../constants/configurations.constants';
import { AwsClient } from 'aws4fetch';
import { catchError, forkJoin, from, of, switchMap, timeout } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  private readonly API_TIMEOUT_MS = 15000;
  private awsClient: AwsClient;
  constructor(private loginDetailsService: LoginDetailsService
  ) { }

  callConfigurationApi(url: string) {
    return from(
      this.awsClient.fetch(`${url}`, { method: 'GET', headers: { accept: 'application/vnd.playerinfo.api+json; version=1.0' } })
        .then(async res => {
          if (res.status === 200) {
            localStorage.removeItem('hasAPIFacedError');
          } else if (res.status === 404) {
            localStorage.setItem('hasAPIFacedError', 'true');
          }
          return res.json();
        })
    ).pipe(
      timeout(this.API_TIMEOUT_MS),
      catchError(err => {
        localStorage.setItem('hasAPIFacedError', 'true');
        return of({
          error: true,
          timedOut: err?.name === 'TimeoutError',
          message:
            err?.name === 'TimeoutError'
              ? `Request timed out for ${url}`
              : `Failed to call ${url}`
        });
      })
    );
  }

  getClubRulesAPIData() {
    return from(this.loginDetailsService.getAwsSignatureAuthorizationConfig()).pipe(
      switchMap((awsConfigs) => {
        if (!awsConfigs) {
          return of({
            clubRulesData: { error: true, timedOut: false, message: 'AWS credentials unavailable' },
          });
        }

        this.awsClient = new AwsClient({ accessKeyId: awsConfigs.AccessKey, secretAccessKey: awsConfigs.SecretKey, region: awsConfigs.region, sessionToken: awsConfigs.sessionToken });

        const getClubRulesUrl = this.loginDetailsService.baseUrl + this.loginDetailsService.tenantCode + GET_PLAYER_TYPE_CLUB_RULES(this.loginDetailsService.propertyId, this.loginDetailsService.clientId);
        const clubRulesApi2$ = this.callConfigurationApi(getClubRulesUrl);

        return forkJoin({
          clubRulesData: clubRulesApi2$,
        });
      })
    );
  }

  getConfigurationsApiData() {
    return from(this.loginDetailsService.getAwsSignatureAuthorizationConfig()).pipe(
      switchMap((awsConfigs) => {
        if (!awsConfigs) {
          return of({
            siteIdsData: { error: true, timedOut: false, message: 'AWS credentials unavailable' },
            clubRulesData: { error: true, timedOut: false, message: 'AWS credentials unavailable' },
            offerTypesData: { error: true, timedOut: false, message: 'AWS credentials unavailable' }
          });
        }

        this.awsClient = new AwsClient({ accessKeyId: awsConfigs.AccessKey, secretAccessKey: awsConfigs.SecretKey, region: awsConfigs.region, sessionToken: awsConfigs.sessionToken });

        const getSiteIdsUrl = this.loginDetailsService.baseUrl + this.loginDetailsService.tenantCode + GET_SITE_IDS(this.loginDetailsService.propertyId, this.loginDetailsService.clientId);
        const getClubRulesUrl = this.loginDetailsService.baseUrl + this.loginDetailsService.tenantCode + GET_PLAYER_TYPE_CLUB_RULES(this.loginDetailsService.propertyId, this.loginDetailsService.clientId);
        const getOfferTypesUrl = this.loginDetailsService.baseUrl + this.loginDetailsService.tenantCode + GET_LIST_OF_OFFER_TYPES(this.loginDetailsService.propertyId, this.loginDetailsService.clientId);

        const siteIdsApi1$ = this.callConfigurationApi(getSiteIdsUrl);
        const clubRulesApi2$ = this.callConfigurationApi(getClubRulesUrl);
        const offersTypeApi3$ = this.callConfigurationApi(getOfferTypesUrl);

        return forkJoin({
          siteIdsData: siteIdsApi1$,
          clubRulesData: clubRulesApi2$,
          offerTypesData: offersTypeApi3$
        });
      })
    );
  }
}
